import React, {createRef, useState} from 'react';
import dateformat from 'dateformat';

import useOutsideClick from '@ibibo/use-outside-click';

import * as S from './DateChangeBlock.styles';

import CalendarBlock from '../../../../../../../../hotels-dweb/src/stories/components/hotels/HomePage/CalendarBlock/CalendarBlockv2';

const DateChangeBlock = ({dateInfo, updateParams}) => {
  const {checkin, checkout} = dateInfo;

  const checkinRef = createRef();
  const checkoutRef = createRef();

  const [calendarMode, setCalendarMode] = useState('');

  const updateQueryCaller = (data) => {
    if ((data.checkin && data.checkin.date.toString() !== new Date(checkin).toString()) || (data.checkout && data.checkout.date.toString() !== new Date(checkout).toString())) {
      updateParams(data);
    }
  }

  const updateCalendarState = (event, key) => {
    event.stopPropagation();
    setCalendarMode(key);
  }
  
  useOutsideClick(checkinRef, () => {
    setCalendarMode('');
  });
  
  useOutsideClick(checkoutRef, () => {
    setCalendarMode('');
  });

  return(
    <S.DateChangeMainWrap>
      <S.DateChangeInnerWrap>
        <S.DateCheckLabel>NEW CHECK IN</S.DateCheckLabel>
        <S.DateCheckCalender onClick={(e) => updateCalendarState(e, 'checkin')}>
          {dateformat(checkin, 'dd mmm yyyy')} <span>{dateformat(checkin, 'ddd')}</span>
        </S.DateCheckCalender>
        {(calendarMode === 'checkin' && <S.CalendarWrapper>
          <CalendarBlock
            ref={checkinRef}
            isSearchWidget={true}
            isCheckinMode={calendarMode === 'checkin'}
            isCheckoutMode={calendarMode === 'checkout'}
            onSelection={() => setCalendarMode('checkout')}
            updateQueryCaller={updateQueryCaller}
            checkin={{date: new Date(checkin)}}
            checkout={{date: new Date(checkout)}}
          />
        </S.CalendarWrapper>) || null}
      </S.DateChangeInnerWrap>

      <S.DateChangeInnerWrap>
        <S.DateCheckLabel>NEW CHECK OUT</S.DateCheckLabel>
        <S.DateCheckCalender onClick={(e) => updateCalendarState(e, 'checkout')}>
          {dateformat(checkout, 'dd mmm yyyy')} <span>{dateformat(checkout, 'ddd')}</span>
        </S.DateCheckCalender>
        {(calendarMode === 'checkout' && <S.CalendarWrapper>
          <CalendarBlock
            ref={checkoutRef}
            isSearchWidget={true}
            isCheckinMode={calendarMode === 'checkin'}
            isCheckoutMode={calendarMode === 'checkout'}
            onSelection={() => setCalendarMode('')}
            updateQueryCaller={updateQueryCaller}
            checkin={{date: new Date(checkin)}}
            checkout={{date: new Date(checkout)}}
          />
        </S.CalendarWrapper>) || null}
      </S.DateChangeInnerWrap>
    </S.DateChangeMainWrap>
  );
};

export default DateChangeBlock;